import {useEffect, useState} from "react";
import {Box, Button, Grid, makeStyles} from "@material-ui/core";
import {useDispatch, useSelector} from "react-redux";
import {moveNextPage, updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {apiClient} from "../../../../../config/apiClient";
import {createReelExperience} from "../../../../../store/actions";
import Config from "../../../../../config/config";
import UtilService from '../../../../../helper/service';
import {useHistory, useLocation} from "react-router";
import moment from 'moment-timezone';
import {updateUserMetricsValue} from '../../../../../store/actions/auth/auth'
import { Loading } from "../../../../atoms/commonLoadings";

const useStyles = makeStyles(() => ({
  subTitle: {
    fontSize: 23,
    fontFamily: 'roboto-bold',
    margin: '25px 0 0',
    color: '#697683'
  },
  subTitle1: {
    fontSize: 24,
    margin: '0',
    fontFamily: 'roboto-bold',
    color: '#697683',
    letterSpacing: '-0.36px'
  },
  description: {
    fontSize: 18,
    fontFamily: 'roboto-regular',
    color: '#017AEF',
    margin: '12px 0 0',
    letterSpacing: '-0.27px',
    cursor: 'pointer',
    '&:hover': {
      color:'#0f9fef'
    }
  },
  sessiondescription: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    marginTop:'20px'
  },
  videoClipWrapper:{
    width: 210,
    borderRadius: 20,
    position:'relative',
    marginRight:20,
    '&:last-child':{
      marginRight:0
    }
  },
  videoClip: {
    width: 210,
    height: 135,
    borderRadius: 20,
    background:'#e5e5e5',
  },
  remove: {
    position: 'absolute',
    right: -10,
    top: -14,
    // width: '24px',
    '&:hover': {
        cursor: 'pointer'
    },
    
  },
  noneInvite: {
    fontSize: 18,
    fontFamily: 'roboto-bold',
    color:'#ED564A'
  },
  goLiveBtn: {
    width: 144,
    height: 54,
    borderRadius: 6,
    background: '#017AEF',
    color: '#fff',
    textTransform: 'none',
    fontSize: 19,
    float: 'right',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
  },
  participantsIcon: {
    width: 24,
    height: 24
  },
  rootdiv:{
    '@media only screen and (min-width: 2000px)': {
      width: '70%'
    },
  }
}));

function ReelReview(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const { userMetrics, page } = useSelector((state: any) => state.creatorExperienceBuilder);
  const {
    asyncStartDateTime,
    asyncEndDateTime,
    sessionCode,
    selectedSessions,
    asyncCompleted,
    asyncParticipants,
    item,
    content,
    asyncExperienceName,
    updateBraintrustMetrics,
    startNow,
    reelsLastActivePage,
    createReel,
    sessions
  } = userMetrics;

  const [reel_title, setReelTitle] = useState('');
  const [reel_sessions, setReelSessions] = useState<number[]>([]);
  const { is_loading } = useSelector((state: any) => state.experience);
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const { onRemove, selected } = props;

  useEffect(() => {
    UtilService.addHashTag(history, location.pathname, 'asyncgo');
    setReelTitle("Reel "+moment().format('MM-DD-YYYY'))
  }, []);

  useEffect(() => {
    if(selected){
      dispatch(updateUserMetrics('selectedSessions', selected));
    }
  }, [selected]);

  useEffect(() => {
    if (asyncExperienceName) {
      setReelTitle(asyncExperienceName);
    }
  }, [asyncExperienceName]);

  useEffect(() => {
    const getStimulus = async () => {
      const res = await apiClient(true).get(`/stimulus/v2/stimulus/${loginUserData.customer_id}/${sessionCode}`);
      dispatch(updateUserMetrics('stimulusList', res.data))
    };
    getStimulus();
  }, [dispatch, loginUserData.customer_id, sessionCode]);

  useEffect(() => {
    const selectedSessionIds :any[] = [];
    if(selectedSessions && selectedSessions.length){
      selectedSessions.map((session: any)=>{
        if(selectedSessionIds.indexOf(parseFloat(session.session_id)) === -1)
          selectedSessionIds.push(parseFloat(session.session_id));
      });
      setReelSessions(selectedSessionIds);
    }
  }, [selectedSessions]);

  const onFinish = () => {
    if (!asyncCompleted) {
      const allemails: any = [];
      asyncParticipants.map((item: any) => {
        const tags: any = [];
        if (item.tags) {
          const itemTags = item.tags.split(",");
          if (itemTags && itemTags.length > 0) {
            itemTags.map((t: any) => {
              if (t && t.trim()) {
                tags.push({ tag_name: t.trim() })
              }
            })
          }
        }
        allemails.push({ email: item.email, tags: tags, is_csv: item.is_csv })
      });
      const timezone = UtilService.storeData;
      let startReelTime: any = "";
      let endReelTime: any = "";

      if (timezone) {
        startReelTime = moment.tz(asyncStartDateTime, timezone).utc().format();
        endReelTime = moment.tz(asyncEndDateTime, timezone).utc().format();
      } else {
        startReelTime = moment(asyncStartDateTime).utc().format();
        endReelTime = moment(asyncEndDateTime).utc().format();
      }
      let request = {};
      const baseRequest = {
        title: reel_title,
        description: '',
        scheduled_start: startReelTime,
        scheduled_end:  endReelTime,
        user_id: loginUserData.user_id,
        status: 'UPCOMING',
        type: 'REELS',
        session_code: sessionCode,
        subcategory: item,
        category: content,
        enable_controls: userMetrics.enable_controls,
        surveylink: userMetrics.surveyLink,
        enable_watermark: userMetrics.enable_watermark,
        participants: allemails,
      };

      if (createReel) { // when create reels from "Measure New Experience" button
        const reelSessions = sessions.map((session: any) => {
          return {
            "title": session.name,
            "session_code": session.session_code
          }
        });

        request = {
          ...baseRequest,
          reel_sessions: null,
          sessions: reelSessions
        }
      } else { // when create reels on Tray modal
        request = {
          ...baseRequest,
          reel_sessions: reel_sessions,
          sessions: null
        }
      }
    
      dispatch(createReelExperience(apolloClient.client, request, () => {
        if (updateBraintrustMetrics) {
          dispatch(updateUserMetricsValue(apolloClient.client, { user_id: loginUserData.user_id, metrics_type: "BRAINTRUST_USES" }));
          dispatch(updateUserMetrics('updateBraintrustMetrics', false))
        }
        dispatch(updateUserMetrics('asyncCompleted', true));
        const nextPage = page + 1;
        dispatch(moveNextPage(nextPage));
        (nextPage > reelsLastActivePage) && dispatch(updateUserMetrics('reelsLastActivePage', nextPage));
      }))
    } else {
      const nextPage = page + 1;
      dispatch(moveNextPage(nextPage));
      (nextPage > reelsLastActivePage) && dispatch(updateUserMetrics('reelsLastActivePage', nextPage));
    }
  };

  return (
    <div className={classes.rootdiv}>
      <p className='creator-main-title mt-65'>Review/Edit and GO LIVE!</p>
      <Grid container spacing={2} >
        <Grid item xs={12} md={9}>
          <p className={classes.subTitle1}>Reel Name</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(createReel ? 3 : 1))}>
            {reel_title}
          </p>
          <p className={classes.subTitle}>Experiences Included</p>
          <Box>
            <Grid container className={classes.sessiondescription}>
              {selectedSessions && selectedSessions.length &&
                selectedSessions.map((sessiondata:any, key:number) => (
                  <Grid className={classes.videoClipWrapper} item key={key} >
                    <div className={classes.videoClipWrapper}>
                      <img src={sessiondata.img ? sessiondata.img : '/assets/images/placeholder.png'} className={classes.videoClip} key={key} alt={'img'}/>
                      <img onClick={() => onRemove(sessiondata)} src={'/assets/icons/dashboard/remove.svg'} className={classes.remove} alt="{close}" />
                      <p style={{width:'100%', textAlign:"center", marginTop:"0px"}}>{sessiondata.name}</p>
                    </div>
                  </Grid>
                ))
              }
            </Grid>
          </Box>
          <p className={classes.subTitle}>Viewing Window</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(createReel ? 4 : 2))}>
            {`${startNow ? 'Now' : UtilService.getParticipantDateFormatString(asyncStartDateTime)} - ${UtilService.getParticipantDateFormatString(asyncEndDateTime)}`}
          </p>
          <p className={classes.subTitle}>Viewing Link</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(createReel ? 5 : 3))}>
            {Config.DEV_ASYNC_INVITE_URL}{loginUserData && loginUserData.invite_link_type === "b" ? '/participant':''}/{sessionCode}
          </p>
          <p className={classes.subTitle}>Participants</p>
          <p className={classes.description} onClick={() => dispatch(moveNextPage(createReel ? 5 : 3))}>
            {
              asyncParticipants.length > 0 ? (
                <span>{asyncParticipants.length} Participants added</span>
              ) : (
                <span>
                  <span className={classes.noneInvite}>None invited yet.</span> <span style={{color: '#697683'}}>Send the link above…or</span> go
                  to the previous step to add them.
                </span>
              )
            }
          </p>
        </Grid>
        <Grid item xs={12} md={3}>
          <Box display="flex">
            <Button color='primary' size='large' className={classes.goLiveBtn} onClick={onFinish} disabled={!!is_loading}>
              {
                !is_loading ? (!asyncCompleted ? 'Go Live!' : 'Next') : (
                  <Loading />
                )
              }
            </Button>
          </Box>
        </Grid>
      </Grid>
      <br/><br/><br/><br/>
    </div>
  )
}

export default ReelReview;
